import { Gallery } from './Gallery';

export type { TypeGalleryProps } from './types';
export default Gallery;
